import React from 'react';

export function MetricStrip({ items }) {
  return (
    <div className="metric-strip" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
      {items.map((it, i) => (
        <div className="metric-cell" key={i}>
          <div className="metric-label">{it.label}</div>
          <div className="metric-value" style={it.color ? { color: it.color } : null}>
            {it.value}
          </div>
          {it.foot && <div className={`metric-foot ${it.dir || ''}`}>{it.foot}</div>}
        </div>
      ))}
    </div>
  );
}